import { render, staticRenderFns } from "./DeclarationParticulars.vue?vue&type=template&id=29950500&scoped=true"
import script from "./DeclarationParticulars.vue?vue&type=script&lang=js"
export * from "./DeclarationParticulars.vue?vue&type=script&lang=js"
import style0 from "./DeclarationParticulars.vue?vue&type=style&index=0&id=29950500&prod&scoped=true&lang=css"
import style1 from "./DeclarationParticulars.vue?vue&type=style&index=1&id=29950500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29950500",
  null
  
)

export default component.exports